import React, { Component } from 'react';
import Hls from 'hls.js';
import { VideoSrcIsEqual } from '../../helpers/Utils';
import { HTMLVideoElementAdapter } from 'bitmovin-analytics';

import Button from '@material-ui/core/Button';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import PlayIcon from '@material-ui/icons/PlayCircleOutline';

export default class VideoPlayerHLS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: props.src,
      userId: props.userId,
      isMuted: true,
      isPaused: true
    };

    this.hls = new Hls();
    this.videoRef = React.createRef();
    this.updateVideoHandlers = this.updateVideoHandlers.bind(this);
    this.updateVideoSrc = this.updateVideoSrc.bind(this);
    this.scrollIntoView = this.scrollIntoView.bind(this);
    this.play = this.play.bind(this);
    this.unMute = this.unMute.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!VideoSrcIsEqual(nextProps.src, prevState.src)) {
      return {
        src: nextProps.src
      };
    }
    else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!VideoSrcIsEqual(prevProps.src, this.props.src)) {
      this.setState( { src: this.props.src }, () => this.updateVideoSrc());
    }
  }

  componentDidMount() {
    this.updateVideoHandlers();
    this.updateVideoSrc();
  }

  updateVideoHandlers() {
    const video = this.videoRef.current;
    if (video) {
      video.addEventListener('play', e => {
        console.log('playing:',e.target.currentSrc);
        this.setState ({ isPaused: e.target.paused });
      }, false);
      video.addEventListener('pause', e => {
        console.log('paused:',e.target.paused);
        this.setState ({ isPaused: e.target.paused });
      }, false);
      video.addEventListener('volumechange', e => {
        console.log('volumechanged:',e.target.volume);
        this.setState ({ isMuted: e.target.muted });
      }, false);
    }
  }

  updateVideoSrc() {
    const video = this.videoRef.current;
    const { src, userId } = this.state;

      // setup bitmovin analytics
    const config = {
      videoId: src.videoId,
      title: src.videoTitle,
      userId: userId
    };
    new HTMLVideoElementAdapter(config, video);

    // play the video
    this.hls.destroy();
    this.hls = new Hls();
    const hls = this.hls;
    if (src.videoUrl) {
      if (Hls.isSupported()) {
        hls.attachMedia(video);
        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          hls.loadSource(src.videoUrl);
          hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
            video.play();
            this.scrollIntoView();
            console.log(`Playing: ${src.videoUrl}`);
          });
        });
      }
    }
  }

  scrollIntoView() {
    setTimeout(() => {
      this.videoRef.current.scrollIntoView({ behavior: 'smooth' })
    }, 500);
  }

  unMute() {
    const video = this.videoRef.current;
    video.muted = false;
  }

  play() {
    const video = this.videoRef.current;
    video.play();
  }

  render() {
    const { isPaused, isMuted } = this.state;
    return (
      <>
      <div><video ref={this.videoRef} style={{width: "100%"}} controls autoPlay loop muted playsInline></video></div>
      { isPaused && (
        <div><Button color="secondary" variant="contained" startIcon={<PlayIcon />} onClick={e => this.play()} >Your player is paused. Click to play ... </Button></div>
      )}
      { !isPaused && isMuted && (
        <div><Button color="secondary" variant="contained" startIcon={<VolumeOffIcon />} onClick={e => this.unMute()} >Your player is muted. Click to unmute audio ... </Button></div>
      )}
      </>
    );
  }

}